export function scrollLock(lock = true) {
  const action = lock ? 'add' : 'remove';
  document.documentElement.classList[action]('noscroll');
}

export const clear = (node: Node): void => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

export const transitionEnd = (
  element: HTMLElement,
  callback: CallableFunction,
  options: Object = {},
): void => {
  const hasDuration = parseFloat(getComputedStyle(element).getPropertyValue('transition-duration') || '0') !== 0;

  if (hasDuration) {
    element.addEventListener('transitionend', (event) => {
      callback(event);
    }, options);
  } else {
    callback();
  }
};

export const repaint = (node: HTMLElement): void => {
  // eslint-disable-next-line no-void
  void (node.offsetHeight);
};

export default {
  clear,
  transitionEnd,
  repaint,
};
